import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReservationsService {
  reservation$ = new Subject<string>();

  get $reservationChange() {
    return this.reservation$.asObservable();
  }

  setReservation(guestId: string) {
    this.reservation$.next(guestId);
  }
}
